// extracted by mini-css-extract-plugin
export default {"loader":"FullPageLoader_loader__cI8qo"};